var _style, _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 12 12",
    style: {
      enableBackground: "new 0 0 12 12"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n  .st0{fill:#666666;}\n")), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Invoice-Manager"
  }, /*#__PURE__*/React.createElement("g", {
    id: "documents-rep-1",
    transform: "translate(-116.000000, -197.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(116.000000, 194.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_arrow_back_18px",
    transform: "translate(6.000000, 9.000000) rotate(-90.000000) translate(-6.000000, -9.000000) translate(0.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    className: "st0",
    points: "5.2,0 5.2,9.1 1.1,4.9 0,6 6,12 12,6 10.9,4.9 6.8,9.1 6.8,0  "
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrowRight.ec4243a0d07663199a7c3161ac356547.svg";
export { ForwardRef as ReactComponent };